import React from "react";

import { ResourceCarousel } from "../widgets/resource-carousel";
import { BaseTypeCarouselItem } from "../widgets/base-type-carousel-item";

export const BaseTypeCarousel = (props) => {
  const { current: previewIndex, dataSource, setPreviewIndex, loading } = props;
  return (
    <ResourceCarousel
      loading={loading}
      current={previewIndex}
      dataSource={dataSource}
      itemRender={(item) => {
        return (
          <div
            key={item.id}
            className="carousel-item"
            style={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BaseTypeCarouselItem
              detail={item}
              activeItem={dataSource[previewIndex]}
              {...props}
            />
          </div>
        );
      }}
      onChange={setPreviewIndex}
      enableMouseEvents
    />
  );
};


// WEBPACK FOOTER //
// ./src/containers/Video/tab-pages/base-type.js